import { render } from "./ContactCardView.vue?vue&type=template&id=e5f3a754&scoped=true&ts=true"
import script from "./ContactCardView.vue?vue&type=script&lang=ts"
export * from "./ContactCardView.vue?vue&type=script&lang=ts"

import "./ContactCardView.vue?vue&type=style&index=0&id=e5f3a754&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/sms-166dx-web-frontend-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f3a754"]])

export default __exports__